export default __webpack_public_path__ + "alberta-fab-pdf.47d7dfb0c7611d3d6aa3.svg";